import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

import CustomSelect from 'components/CustomSelect'
import { Modal } from 'react-bootstrap'

import { GET, httpOk, PATCH, POST } from 'helpers/api'
import { checkPermission, sources } from 'helpers/helpers';

import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';

const initData = {
	distributor_id: '',
	items: [
		{
			box_id: '',
			box_quantity: '',
			unit_id: '',
			unit_price: '',
		}
	],
	source: '',
	comment: '',
};

function CreateOrder({ modal, setModal, getData, id }) {
	const { t } = useTranslation();

	const [sendData, setSendData] = useState(structuredClone(initData));

	const [distributors, setDistributors] = useState([])
	const [boxes, setBoxes] = useState([])

	async function create() {
		var sendDataCopy = { ...sendData }
		var response;
		if (id) {
			response = await PATCH(`/sales/orders/${id}/`, sendDataCopy)
		} else {
			response = await POST('/sales/orders/', sendDataCopy)
		}
		if (httpOk(response)) {
			setModal(false);
			setSendData(structuredClone(initData))
			getData();
		}
	}

	function handleChange(e) {
		var sendDataCopy = { ...sendData };
		sendDataCopy[e.target.name] = e.target.value;
		setSendData(sendDataCopy);
	}

	function selectItem(option, index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.items[index].box_id = option?.id;
		setSendData(sendDataCopy);
	}

	function handleChangeItem(e, index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.items[index][e.target.name] = e.target.value;
		setSendData(sendDataCopy);
	}

	function deleteItem(index) {
		var sendDataCopy = { ...sendData };
		sendDataCopy.items.splice(index, 1)
		setSendData(sendDataCopy);
	}

	function addToList() {
		var sendDataCopy = { ...sendData };
		sendDataCopy.items.push({
			box_id: '',
			box_quantity: '',
			unit_id: '',
			unit_price: '',
		})
		setSendData(sendDataCopy);
	}


	useEffect(() => {
		async function getDistributors() {
			const response = await GET('/sales/distributors/')
			if (httpOk(response)) {
				setDistributors(response.data)
			}
		}

		async function getBoxes() {
			const response = await GET('/recipes/boxes/', { size: 1000 })
			if (httpOk(response)) {
				setBoxes(response.data)
			}
		}

		getDistributors()
		getBoxes()
	}, []);

	useEffect(() => {
		async function getData() {
			const response = await GET(`/sales/orders/${id}/`, { size: 1000 })
			if (httpOk(response)) {
				setSendData(response.data)
			}
		}

		if (modal && id) {
			getData();
		} else {
			setSendData(initData)
		}
	}, [modal, id]);

	return (
		<>
			<Modal show={modal} centered onHide={() => setModal(false)}>
				<i className="uil-times" onClick={() => setModal(false)}></i>
				<div className="modal-title mb-12">
					{id ?
						t('edit_distributor_order')
						:
						t('create_distributor_order')
					}
				</div>
				<div className="modal-subtitle mb-32">
					{t('order_management_distributors_desc')}
				</div>

				<div className="d-flex flex-column gap-16 mb-32">
					<div className="form-group">
						<label>{t('distributor')}</label>
						<CustomSelect
							options={distributors}
							value={distributors?.find(option => option.id === sendData?.distributor_id) || ''}
							onChange={(option) => setSendData({ ...sendData, distributor_id: option.id, unit_id: option.unit_id })}
							placeholder={t('select_distributor')}
						/>
					</div>

					<div className="form-group">
						<label>{t('order_number')}</label>
						<input type="text" placeholder={t('order_number')} name="order_number"
							value={sendData.order_number} onChange={(e) => handleChange(e)} />
					</div>

					<div className="form-group">
						<label>{t('source')}</label>
						<CustomSelect
							options={sources}
							value={sources?.find(option => option.id === sendData?.source) || ''}
							onChange={(option) => setSendData({ ...sendData, source: option.id })}
							placeholder={t('select_source')}
						/>
					</div>

					<div className="card forth">
						<div className="d-between mb-16">
							<div>
								{t('boxes')}
							</div>
							<button className="white small" onClick={() => addToList()}>
								<PlusIcon />
								{t('add_box')}
							</button>
						</div>

						<div className="d-flex flex-column gap-12">
							{sendData?.items?.map((item, index) => (
								<div className="d-flex gap-8" key={index}>
									<div style={{ minWidth: '200px', }}>
										<CustomSelect
											options={boxes}
											value={boxes?.find(option => option.id === item?.box_id) || ''}
											getOptionLabel={(option) => option.name}
											onChange={(option) => selectItem(option, index)}
											placeholder={t('sku')}
											isClearable={false}
										/>

									</div>

									<input type="text" placeholder={t('quantity')} name="box_quantity" className="w-100"
										value={item.box_quantity} onChange={(e) => handleChangeItem(e, index)} />

									{checkPermission("prices.view.full") &&
										<input type="text" placeholder={t('unit_price')} name="unit_price" className="w-100"
											value={item.unit_price} onChange={(e) => handleChangeItem(e, index)} />
									}
									<button className="transparent small" style={{ height: '36px' }} onClick={() => deleteItem(index)}>
										<DeleteIcon />
									</button>
								</div>
							))}
						</div>
					</div>

					<div className="form-group">
						<label>{t('comment')}</label>
						<input type="text" placeholder={t('additional_info')} name="comment"
							value={sendData.comment} onChange={(e) => handleChange(e)} />
					</div>

				</div>

				<div className="modal-footer">
					<button className="white" onClick={() => setModal(false)}>
						{t('cancel')}
					</button>
					<button className="dark" onClick={() => create()}>
						{id ?
							t('edit_order')
							:
							t('create_order')
						}
					</button>
				</div>
			</Modal>
		</>
	)
}

export default CreateOrder